import React from 'react';
import { Button } from '@mui/material';
import { Auth } from 'aws-amplify';
import { clearAllImpersonation } from 'utils/impersonation';

const signOut = async () => {
  try {
    clearAllImpersonation();
    await Auth.signOut();
  } catch (error: any) {
    console.error('Error signing out: ', error);
  }
};

/* Wrapper component for the button that allows the user to log out */
export const LogoutButton = () => (
  <Button
    onClick={signOut}
  >
    Sign out
  </Button>
);
